/* eslint-disable no-console */
import { ExportFormat } from "@iventis/domain-model/model/exportFormat";
import { MetricName } from "@iventis/domain-model/model/metricName";
import { incrementMonitoringCount } from "../set-monitoring-metric";
import { MetricEvent } from "../metric-types";

export function exportMapMonitoringMetric(exportFormat: ExportFormat, event: Partial<MetricEvent> = {}) {
    switch (exportFormat) {
        case ExportFormat.Png:
            incrementMonitoringCount({ ...event, name: MetricName.PLAN_EXPORTED_PNG });
            break;
        case ExportFormat.Pdf:
            incrementMonitoringCount({ ...event, name: MetricName.PLAN_EXPORTED_PDF });
            break;
        default:
            console.warn(`Export format ${exportFormat} is not supported for monitoring`);
    }
}
